/* AUTOGENERATED from /home/philipp/Preisliste/prices.py — DO NOT EDIT */
/* Run: python3 /home/philipp/Preisliste/prices_to_js.py */
window.BAMINGER_PRICES = {
  "EU": {
    "currency": "EUR",
    "symbol": "€",
    "transporter": {
      "tiers": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_ek": 75,
          "kunstleder_ek": 86,
          "stoff_uvp": 144,
          "kunstleder_uvp": 166,
          "kunstleder_20_ek": 95,
          "kunstleder_20_uvp": 182
        },
        {
          "tier": 2,
          "stoff_ek": 129,
          "kunstleder_ek": 164,
          "stoff_uvp": 247,
          "kunstleder_uvp": 314,
          "kunstleder_20_ek": 180,
          "kunstleder_20_uvp": 346
        },
        {
          "tier": 3,
          "stoff_ek": 144,
          "kunstleder_ek": 184,
          "stoff_uvp": 276,
          "kunstleder_uvp": 353,
          "kunstleder_20_ek": 202,
          "kunstleder_20_uvp": 388
        },
        {
          "tier": 4,
          "stoff_ek": 189,
          "kunstleder_ek": 239,
          "stoff_uvp": 362,
          "kunstleder_uvp": 458,
          "kunstleder_20_ek": 263,
          "kunstleder_20_uvp": 505
        },
        {
          "tier": 5,
          "stoff_ek": 234,
          "kunstleder_ek": 289,
          "stoff_uvp": 449,
          "kunstleder_uvp": 554,
          "kunstleder_20_ek": 318,
          "kunstleder_20_uvp": 611
        },
        {
          "tier": 6,
          "stoff_ek": 274,
          "kunstleder_ek": 344,
          "stoff_uvp": 526,
          "kunstleder_uvp": 660,
          "kunstleder_20_ek": 378,
          "kunstleder_20_uvp": 726
        },
        {
          "tier": 7,
          "stoff_ek": 304,
          "kunstleder_ek": 389,
          "stoff_uvp": 583,
          "kunstleder_uvp": 746,
          "kunstleder_20_ek": 428,
          "kunstleder_20_uvp": 822
        },
        {
          "tier": 8,
          "stoff_ek": 364,
          "kunstleder_ek": 459,
          "stoff_uvp": 698,
          "kunstleder_uvp": 881,
          "kunstleder_20_ek": 505,
          "kunstleder_20_uvp": 970
        },
        {
          "tier": 9,
          "stoff_ek": 409,
          "kunstleder_ek": 499,
          "stoff_uvp": 785,
          "kunstleder_uvp": 958,
          "kunstleder_20_ek": 549,
          "kunstleder_20_uvp": 1054
        }
      ]
    },
    "lkw": {
      "tiers": [
        1,
        2,
        3,
        6,
        7
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_ek": 71,
          "kunstleder_ek": 84,
          "stoff_uvp": 137,
          "kunstleder_uvp": 161,
          "kunstleder_20_ek": 92,
          "kunstleder_20_uvp": 176
        },
        {
          "tier": 2,
          "stoff_ek": 134,
          "kunstleder_ek": 160,
          "stoff_uvp": 257,
          "kunstleder_uvp": 307,
          "kunstleder_20_ek": 176,
          "kunstleder_20_uvp": 338
        },
        {
          "tier": 3,
          "stoff_ek": 199,
          "kunstleder_ek": 239,
          "stoff_uvp": 382,
          "kunstleder_uvp": 458,
          "kunstleder_20_ek": 263,
          "kunstleder_20_uvp": 505
        },
        {
          "tier": 6,
          "stoff_ek": 274,
          "kunstleder_ek": 344,
          "stoff_uvp": 526,
          "kunstleder_uvp": 660,
          "kunstleder_20_ek": 378,
          "kunstleder_20_uvp": 726
        },
        {
          "tier": 7,
          "stoff_ek": 304,
          "kunstleder_ek": 389,
          "stoff_uvp": 583,
          "kunstleder_uvp": 746,
          "kunstleder_20_ek": 428,
          "kunstleder_20_uvp": 822
        }
      ]
    },
    "pickup": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_ek": 81,
          "kunstleder_ek": 96,
          "stoff_uvp": 156,
          "kunstleder_uvp": 185,
          "kunstleder_20_ek": 106,
          "kunstleder_20_uvp": 204
        },
        {
          "tier": 2,
          "stoff_ek": 149,
          "kunstleder_ek": 186,
          "stoff_uvp": 286,
          "kunstleder_uvp": 358,
          "kunstleder_20_ek": 205,
          "kunstleder_20_uvp": 394
        },
        {
          "tier": 5,
          "stoff_ek": 254,
          "kunstleder_ek": 309,
          "stoff_uvp": 487,
          "kunstleder_uvp": 593,
          "kunstleder_20_ek": 340,
          "kunstleder_20_uvp": 653
        }
      ]
    },
    "pkw": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_ek": 81,
          "kunstleder_ek": 96,
          "stoff_uvp": 156,
          "kunstleder_uvp": 185,
          "kunstleder_20_ek": 106,
          "kunstleder_20_uvp": 204
        },
        {
          "tier": 2,
          "stoff_ek": 149,
          "kunstleder_ek": 186,
          "stoff_uvp": 286,
          "kunstleder_uvp": 358,
          "kunstleder_20_ek": 205,
          "kunstleder_20_uvp": 394
        },
        {
          "tier": 5,
          "stoff_ek": 254,
          "kunstleder_ek": 309,
          "stoff_uvp": 487,
          "kunstleder_uvp": 593,
          "kunstleder_20_ek": 340,
          "kunstleder_20_uvp": 653
        }
      ]
    },
    "spezial": {
      "tiers": [
        [
          1,
          10
        ],
        [
          10,
          50
        ],
        [
          50,
          null
        ]
      ],
      "rows": [
        {
          "tier": [
            1,
            10
          ],
          "stoff_ek": 87,
          "kunstleder_ek": 99,
          "stoff_uvp": 167,
          "kunstleder_uvp": 190,
          "kunstleder_20_ek": 109,
          "kunstleder_20_uvp": 209
        },
        {
          "tier": [
            10,
            50
          ],
          "stoff_ek": 81,
          "kunstleder_ek": 89,
          "stoff_uvp": 156,
          "kunstleder_uvp": 170,
          "kunstleder_20_ek": 98,
          "kunstleder_20_uvp": 188
        },
        {
          "tier": [
            50,
            null
          ],
          "stoff_ek": 77,
          "kunstleder_ek": 84,
          "stoff_uvp": 148,
          "kunstleder_uvp": 161,
          "kunstleder_20_ek": 92,
          "kunstleder_20_uvp": 176
        }
      ]
    },
    "fussmatten": {
      "tiers": [
        [
          1,
          4
        ],
        [
          5,
          19
        ],
        [
          20,
          49
        ],
        [
          50,
          99
        ],
        [
          100,
          249
        ],
        [
          250,
          999
        ],
        [
          1000,
          null
        ]
      ],
      "rows": [
        {
          "tier_label": "1-4 Stück",
          "tier_from": 1,
          "tier_to": 4,
          "gummi": {
            "ek": 82,
            "uvp": 126
          },
          "teppich": {
            "ek": 44,
            "uvp": 67
          },
          "velours": {
            "ek": 75,
            "uvp": 115
          }
        },
        {
          "tier_label": "ab 5 Stück",
          "tier_from": 5,
          "tier_to": 19,
          "gummi": {
            "ek": 70,
            "uvp": 108
          },
          "teppich": {
            "ek": 37,
            "uvp": 56
          },
          "velours": {
            "ek": 63,
            "uvp": 97
          }
        },
        {
          "tier_label": "ab 20 Stück",
          "tier_from": 20,
          "tier_to": 49,
          "gummi": {
            "ek": 64,
            "uvp": 98
          },
          "teppich": {
            "ek": 32,
            "uvp": 49
          },
          "velours": {
            "ek": 54,
            "uvp": 83
          }
        },
        {
          "tier_label": "ab 50 Stück",
          "tier_from": 50,
          "tier_to": 99,
          "gummi": {
            "ek": 59,
            "uvp": 91
          },
          "teppich": {
            "ek": 29,
            "uvp": 44
          },
          "velours": {
            "ek": 49,
            "uvp": 76
          }
        },
        {
          "tier_label": "ab 100 Stück",
          "tier_from": 100,
          "tier_to": 249,
          "gummi": {
            "ek": 56,
            "uvp": 86
          },
          "teppich": {
            "ek": 27,
            "uvp": 42
          },
          "velours": {
            "ek": 46,
            "uvp": 71
          }
        },
        {
          "tier_label": "ab 250 Stück",
          "tier_from": 250,
          "tier_to": 999,
          "gummi": {
            "ek": 54,
            "uvp": 83
          },
          "teppich": {
            "ek": 26,
            "uvp": 40
          },
          "velours": {
            "ek": 44,
            "uvp": 67
          }
        },
        {
          "tier_label": "ab 1.000 Stück",
          "tier_from": 1000,
          "tier_to": null,
          "gummi": {
            "ek": 52,
            "uvp": 80
          },
          "teppich": {
            "ek": 25,
            "uvp": 38
          },
          "velours": {
            "ek": 42,
            "uvp": 65
          }
        }
      ]
    },
    "logo_sitz_per_seat": 6,
    "logo_sitz_per_seat_brutto": 12,
    "logo_sitz_min_count": 6,
    "logo_sitz_setup_fee": 30,
    "logo_sitz_setup_fee_brutto": 58,
    "logo_fm_per_row": 12,
    "logo_fm_per_row_brutto": 23,
    "logo_fm_setup_fee": 30,
    "logo_fm_setup_fee_brutto": 58,
    "kunstleder_verstaerkung_per_seat": 10,
    "transport_sitz_per_paket": 15,
    "transport_fm_per_paket": 18,
    "b2b_staffel": [
      [
        10,
        0.05
      ],
      [
        40,
        0.12
      ]
    ]
  },
  "CH": {
    "currency": "CHF",
    "symbol": "CHF",
    "transporter": {
      "tiers": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_ek": 99,
          "kunstleder_ek": 114,
          "stoff_uvp": 158,
          "kunstleder_uvp": 182,
          "kunstleder_20_ek": 125,
          "kunstleder_20_uvp": 200
        },
        {
          "tier": 2,
          "stoff_ek": 169,
          "kunstleder_ek": 214,
          "stoff_uvp": 270,
          "kunstleder_uvp": 342,
          "kunstleder_20_ek": 235,
          "kunstleder_20_uvp": 376
        },
        {
          "tier": 3,
          "stoff_ek": 189,
          "kunstleder_ek": 244,
          "stoff_uvp": 302,
          "kunstleder_uvp": 390,
          "kunstleder_20_ek": 268,
          "kunstleder_20_uvp": 429
        },
        {
          "tier": 4,
          "stoff_ek": 249,
          "kunstleder_ek": 314,
          "stoff_uvp": 398,
          "kunstleder_uvp": 502,
          "kunstleder_20_ek": 345,
          "kunstleder_20_uvp": 552
        },
        {
          "tier": 5,
          "stoff_ek": 309,
          "kunstleder_ek": 379,
          "stoff_uvp": 494,
          "kunstleder_uvp": 606,
          "kunstleder_20_ek": 417,
          "kunstleder_20_uvp": 667
        },
        {
          "tier": 6,
          "stoff_ek": 359,
          "kunstleder_ek": 449,
          "stoff_uvp": 574,
          "kunstleder_uvp": 718,
          "kunstleder_20_ek": 494,
          "kunstleder_20_uvp": 790
        },
        {
          "tier": 7,
          "stoff_ek": 399,
          "kunstleder_ek": 509,
          "stoff_uvp": 638,
          "kunstleder_uvp": 814,
          "kunstleder_20_ek": 560,
          "kunstleder_20_uvp": 896
        },
        {
          "tier": 8,
          "stoff_ek": 479,
          "kunstleder_ek": 604,
          "stoff_uvp": 766,
          "kunstleder_uvp": 966,
          "kunstleder_20_ek": 664,
          "kunstleder_20_uvp": 1062
        },
        {
          "tier": 9,
          "stoff_ek": 539,
          "kunstleder_ek": 654,
          "stoff_uvp": 862,
          "kunstleder_uvp": 1046,
          "kunstleder_20_ek": 719,
          "kunstleder_20_uvp": 1150
        }
      ]
    },
    "lkw": {
      "tiers": [
        1,
        2,
        3,
        6,
        7
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_ek": 94,
          "kunstleder_ek": 111,
          "stoff_uvp": 150,
          "kunstleder_uvp": 178,
          "kunstleder_20_ek": 122,
          "kunstleder_20_uvp": 195
        },
        {
          "tier": 2,
          "stoff_ek": 177,
          "kunstleder_ek": 211,
          "stoff_uvp": 283,
          "kunstleder_uvp": 338,
          "kunstleder_20_ek": 232,
          "kunstleder_20_uvp": 371
        },
        {
          "tier": 3,
          "stoff_ek": 262,
          "kunstleder_ek": 315,
          "stoff_uvp": 419,
          "kunstleder_uvp": 504,
          "kunstleder_20_ek": 346,
          "kunstleder_20_uvp": 554
        },
        {
          "tier": 6,
          "stoff_ek": 359,
          "kunstleder_ek": 449,
          "stoff_uvp": 574,
          "kunstleder_uvp": 718,
          "kunstleder_20_ek": 494,
          "kunstleder_20_uvp": 790
        },
        {
          "tier": 7,
          "stoff_ek": 399,
          "kunstleder_ek": 509,
          "stoff_uvp": 638,
          "kunstleder_uvp": 814,
          "kunstleder_20_ek": 560,
          "kunstleder_20_uvp": 896
        }
      ]
    },
    "pickup": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_ek": 106,
          "kunstleder_ek": 126,
          "stoff_uvp": 170,
          "kunstleder_uvp": 202,
          "kunstleder_20_ek": 139,
          "kunstleder_20_uvp": 222
        },
        {
          "tier": 2,
          "stoff_ek": 196,
          "kunstleder_ek": 246,
          "stoff_uvp": 314,
          "kunstleder_uvp": 394,
          "kunstleder_20_ek": 271,
          "kunstleder_20_uvp": 434
        },
        {
          "tier": 5,
          "stoff_ek": 336,
          "kunstleder_ek": 406,
          "stoff_uvp": 538,
          "kunstleder_uvp": 650,
          "kunstleder_20_ek": 447,
          "kunstleder_20_uvp": 715
        }
      ]
    },
    "pkw": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_ek": 106,
          "kunstleder_ek": 126,
          "stoff_uvp": 170,
          "kunstleder_uvp": 202,
          "kunstleder_20_ek": 139,
          "kunstleder_20_uvp": 222
        },
        {
          "tier": 2,
          "stoff_ek": 196,
          "kunstleder_ek": 246,
          "stoff_uvp": 314,
          "kunstleder_uvp": 394,
          "kunstleder_20_ek": 271,
          "kunstleder_20_uvp": 434
        },
        {
          "tier": 5,
          "stoff_ek": 336,
          "kunstleder_ek": 406,
          "stoff_uvp": 538,
          "kunstleder_uvp": 650,
          "kunstleder_20_ek": 447,
          "kunstleder_20_uvp": 715
        }
      ]
    },
    "spezial": {
      "tiers": [
        [
          1,
          10
        ],
        [
          10,
          50
        ],
        [
          50,
          null
        ]
      ],
      "rows": [
        {
          "tier": [
            1,
            10
          ],
          "stoff_ek": 114,
          "kunstleder_ek": 130,
          "stoff_uvp": 182,
          "kunstleder_uvp": 208,
          "kunstleder_20_ek": 143,
          "kunstleder_20_uvp": 229
        },
        {
          "tier": [
            10,
            50
          ],
          "stoff_ek": 106,
          "kunstleder_ek": 117,
          "stoff_uvp": 170,
          "kunstleder_uvp": 187,
          "kunstleder_20_ek": 129,
          "kunstleder_20_uvp": 206
        },
        {
          "tier": [
            50,
            null
          ],
          "stoff_ek": 101,
          "kunstleder_ek": 111,
          "stoff_uvp": 162,
          "kunstleder_uvp": 178,
          "kunstleder_20_ek": 122,
          "kunstleder_20_uvp": 195
        }
      ]
    },
    "fussmatten": {
      "tiers": [
        [
          1,
          4
        ],
        [
          5,
          19
        ],
        [
          20,
          49
        ],
        [
          50,
          99
        ],
        [
          100,
          249
        ],
        [
          250,
          999
        ],
        [
          1000,
          null
        ]
      ],
      "rows": [
        {
          "tier_label": "1-4 Stück",
          "tier_from": 1,
          "tier_to": 4,
          "gummi": {
            "ek": 125,
            "uvp": 160
          },
          "teppich": {
            "ek": 88,
            "uvp": 113
          },
          "velours": {
            "ek": 150,
            "uvp": 192
          }
        },
        {
          "tier_label": "ab 5 Stück",
          "tier_from": 5,
          "tier_to": 19,
          "gummi": {
            "ek": 107,
            "uvp": 137
          },
          "teppich": {
            "ek": 74,
            "uvp": 95
          },
          "velours": {
            "ek": 126,
            "uvp": 162
          }
        },
        {
          "tier_label": "ab 20 Stück",
          "tier_from": 20,
          "tier_to": 49,
          "gummi": {
            "ek": 98,
            "uvp": 126
          },
          "teppich": {
            "ek": 64,
            "uvp": 82
          },
          "velours": {
            "ek": 109,
            "uvp": 140
          }
        },
        {
          "tier_label": "ab 50 Stück",
          "tier_from": 50,
          "tier_to": 99,
          "gummi": {
            "ek": 90,
            "uvp": 115
          },
          "teppich": {
            "ek": 58,
            "uvp": 74
          },
          "velours": {
            "ek": 99,
            "uvp": 127
          }
        },
        {
          "tier_label": "ab 100 Stück",
          "tier_from": 100,
          "tier_to": 249,
          "gummi": {
            "ek": 85,
            "uvp": 109
          },
          "teppich": {
            "ek": 54,
            "uvp": 69
          },
          "velours": {
            "ek": 92,
            "uvp": 118
          }
        },
        {
          "tier_label": "ab 250 Stück",
          "tier_from": 250,
          "tier_to": 999,
          "gummi": {
            "ek": 82,
            "uvp": 105
          },
          "teppich": {
            "ek": 52,
            "uvp": 67
          },
          "velours": {
            "ek": 88,
            "uvp": 113
          }
        },
        {
          "tier_label": "ab 1.000 Stück",
          "tier_from": 1000,
          "tier_to": null,
          "gummi": {
            "ek": 79,
            "uvp": 101
          },
          "teppich": {
            "ek": 50,
            "uvp": 64
          },
          "velours": {
            "ek": 85,
            "uvp": 109
          }
        }
      ]
    },
    "logo_sitz_per_seat": 8,
    "logo_sitz_per_seat_brutto": 13,
    "logo_sitz_min_count": 6,
    "logo_sitz_setup_fee": 40,
    "logo_sitz_setup_fee_brutto": 64,
    "logo_fm_per_row": 15,
    "logo_fm_per_row_brutto": 24,
    "logo_fm_setup_fee": 40,
    "logo_fm_setup_fee_brutto": 64,
    "kunstleder_verstaerkung_per_seat": 13,
    "transport_sitz_per_paket": 35,
    "transport_fm_per_paket": 35,
    "b2b_staffel": [
      [
        10,
        0.05
      ],
      [
        40,
        0.12
      ]
    ]
  },
  "_generated_at": "2026-07-04T04:15:59",
  "_source": "prices.py"
};
